'use strict'

define ['./password_reset_confirm.scss'], () ->
  ($scope, $state, RentappService, Flash, $http, RENTAPPLICATION_API_URL, $stateParams ) ->
    token = $stateParams.token
    uidb64 = $stateParams.uidb64
    $scope.resetting_password = false

    $scope.resetPwd = () ->
      if $scope.password != $scope.password_again
        Flash.create('danger', 'Passwords do not match!')
        return
      $scope.resetting_password = true
      $http.post "#{RENTAPPLICATION_API_URL}/api/v1/user/confirm_password_reset/",
        token: token
        uidb64: uidb64
        new_password: $scope.password
        new_password_again: $scope.password_again
      .then ->
        $state.go "root.home.password_reset_done"
      .catch (r) ->
        console.log(Object.values(r.data)[0][0])
        Flash.create('danger', Object.values(r.data)[0][0], 0)
      .finally ->
        $scope.resetting_password = false




// WEBPACK FOOTER //
// ./components/home/password_reset_confirm/password_reset_confirm.coffee